import React from 'react'

import { LabelConfig, LabelType } from './Label.types'
import * as Icons from './Label.icons'

export const LABELS_CONFIGS: Record<LabelType, LabelConfig> = {
  [LabelType.DONE_ACTIVITY]: {
    title: 'Done',
    textColor: '#0a0a0a',
    backgroundColor: '#5cb57b',
    renderIcon: (large) => <Icons.DoneIcon large={large} />
  },
  [LabelType.LOCK]: {
    backgroundColor: '#0a0a0a',
    renderIcon: (large) => <Icons.LockIcon large={large} />
  },
  [LabelType.PREMIUM_ACTIVITY]: {
    title: 'Premium',
    textColor: '#ffffff',
    backgroundColor: '#0a0a0a',
    renderIcon: (large) => <Icons.LockIcon large={large} />
  },
  [LabelType.PRO_ACTIVITY]: {
    title: 'Pro',
    textColor: '#ffffff',
    backgroundColor: '#0a0a0a',
    renderIcon: (large) => <Icons.LockIcon large={large} />
  },
  [LabelType.GIFT_ACTIVITY]: {
    title: 'Gift',
    textColor: '#ffffff',
    backgroundColor: '#0a0a0a',
    renderIcon: (large) => <Icons.GiftIcon large={large} />
  },
  [LabelType.FREE_TIER]: {
    title: 'Free',
    textColor: '#ffffff',
    backgroundColor: '#848484'
  },
  [LabelType.PREMIUM_TIER]: {
    title: 'Premium',
    textColor: '#ffffff',
    backgroundColor: '#1F2631'
  },
  [LabelType.PRO_TIER]: {
    title: 'Pro',
    textColor: '#ffffff',
    backgroundColor: '#1F2631'
  },
  [LabelType.STARS]: {
    textColor: '#0a0a0a',
    backgroundColor: '#f8f8f8',
    renderIcon: (large) => (
      <span className={Icons.styles.starIconContainer}>
        <Icons.StarIcon large={large} />
      </span>
    )
  }
}
